import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import EcoPilot from '../../components/feature/EcoPilot';
import ServicesContent from './components/ServicesContent';

export default function Services() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ServicesContent />
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
    </div>
  );
}